import { render, staticRenderFns } from "./gsr_smzm_report.vue?vue&type=template&id=b20849cc&scoped=true"
import script from "./gsr_smzm_report.vue?vue&type=script&lang=js"
export * from "./gsr_smzm_report.vue?vue&type=script&lang=js"
import style0 from "./gsr_smzm_report.vue?vue&type=style&index=0&id=b20849cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20849cc",
  null
  
)

export default component.exports